import { render, staticRenderFns } from "./MobileSearchCenter.vue?vue&type=template&id=bfa38d6a&scoped=true"
import script from "./MobileSearchCenter.vue?vue&type=script&lang=js"
export * from "./MobileSearchCenter.vue?vue&type=script&lang=js"
import style0 from "./MobileSearchCenter.vue?vue&type=style&index=0&id=bfa38d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa38d6a",
  null
  
)

export default component.exports